/*
 * @FilePath: /mall-fe/src/views/Mobile/components/Floors.tsx
 * @Description: 移动端页面底部展示组件
 *
 */
import React from 'react';
import ProductCategory from './ProductCategory';
import { isArray } from 'libs/utils';
/**
 *
 * @param props.floors 楼层信息
 * @returns
 */
function Floors<T>(props: {
  floors?: Array<FloorsProps extends T ? FloorsProps : never>;
  Components?: () => React.ReactElement;
}) {
  const { floors = [], Components } = props;

  return (
    <div className="floor">
      {isArray(floors)
        ? floors.map((floor, i) => <ProductCategory key={i} product={floor} />)
        : Components
        ? Components()
        : null}
      <style jsx>
        {`
          .floor {
            padding: 0 12px;
          }
        `}
      </style>
    </div>
  );
}

export default Floors;
